import '../../../main/components/ApartmentSelection/style.css'
import './style.scss'
import React, { useRef, useState } from "react";
import InputMask from "react-input-mask";
import Success from "../../../main/components/Popup/Success";
import axios from 'axios';
import { SERVER_POST } from '../../../../const';

const FormSign = ({ className }: any) => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        dataConsent: false,
    });

    const [error, setError] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);

    const validateNameAndPhone = () => {
        const nameRegex = /^[А-ЯЁа-яё]{2,40}$/;
        const phoneRegex = /^(\+7|8)?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/;

        const isNameValid = nameRegex.test(formData.name.trim());
        const isPhoneValid = phoneRegex.test(formData.phone.trim());

        if (!isNameValid) {
            setError("Некорректное имя");
            return false;
        }
        if (!isPhoneValid) {
            setError("Некорректный номер телефона");
            return false;
        }

        return true;
    };

    const validateForm = () => {
        const { dataConsent } = formData;

        if (
            !formData.name ||
            !formData.phone ||
            !formData.email ||
            !dataConsent
        ) {
            setError("Не все поля заполнены");
            return false;
        }

        if (!validateNameAndPhone()) {
            return false;
        }

        setError("");
        return true;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;

        if (type === "checkbox" && name === "conditions") {
            setFormData((prev: any) => ({
                ...prev,
                conditions: checked
                    ? [...prev.conditions, value]
                    : prev.conditions.filter((condition: any) => condition !== value),
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value,
            }));
        }
    };

    const handleNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const nameRegex = /^[А-ЯЁа-яё]*$/;

        if (nameRegex.test(value) || value === '') {
            setFormData((prev) => ({
                ...prev,
                name: value,
            }));
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const isLetter = /^[А-ЯЁа-яё]$/.test(e.key);
        const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);

        if (!isLetter && !isControlKey) {
            e.preventDefault();
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await axios.post(SERVER_POST, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    },
                });

                if (response.status === 200) {
                    console.log('Данные успешно отправлены: ', formData);
                    setSuccessVisible(true);
                    setFormData({
                        name: "",
                        phone: "",
                        email: "",
                        dataConsent: false,
                    })
                }
            } catch (error) {
                console.error('Ошибка отправки данных:', error);
            }
        }
    };

    return <section className="apartment-selection form-single">
        <form className={`form ${className}`} onSubmit={handleSubmit}>
            <div className="form__container">
                <div className="form-title form-single__title">
                    <h2><span><b>Записаться</b> на </span> предпросмотр</h2>
                </div>
                <div className="form-label-column form-label-flex form-single__inputs">
                    <div className="form-label-text">
                        <input
                            type="text"
                            name="name"
                            placeholder="Ваше имя"
                            value={formData.name}
                            onChange={handleNameInput}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div className="form-label-text">
                        <InputMask
                            mask="+7 999 999 99 99"
                            value={formData.phone}
                            onChange={handleChange}
                            className="phone-input"
                            placeholder="Ваш номер телефона"
                        >
                            {(inputProps: any) => <input type="tel" name={'phone'} {...inputProps}
                                className="form__phone" />}
                        </InputMask>
                    </div>
                    <div className="form-label-text">
                        <input
                            className="form__phone"
                            name="email"
                            type="email"
                            placeholder="Ваш E-mail"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                {error && <div className="formError" style={{ marginBottom: '5px' }}>{error}</div>}
                <button className="button form__button form-single__btn">Записаться</button>
                <p className="form-single__checked-info">Нажимая кнопку «Подобрать объект», вы подтверждаете свое
                    согласие на обработку персональных данных</p>

                <label className="form-label-flex form-label-politic">
                    <input
                        type="checkbox"
                        name="dataConsent"
                        checked={formData.dataConsent}
                        onChange={handleChange}
                    />
                    <span>Я даю согласие на обработку своих персональных данных</span>
                </label>
            </div>
        </form>
        {successVisible && <Success onClose={() => setSuccessVisible(false)} />}
    </section>
}

export default FormSign